import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import DropDownMenu from '../../DropDownMenu.jsx';

const messages = defineMessages({
    title: {
        id: 'grid.menu.prematch_filter.title',
        defaultMessage: 'Фильтр событий'
    },
    allTime: {
        id: 'grid.menu.prematch_filter.all_time',
        defaultMessage: 'За всё время'
    },
    nextHour: {
        id: 'grid.menu.prematch_filter.next_hour',
        defaultMessage: 'Ближайший час'
    },
    next2Hours: {
        id: 'grid.menu.prematch_filter.next_2_hours',
        defaultMessage: 'Ближайшие 2 часа'
    },
    next4Hours: {
        id: 'grid.menu.prematch_filter.next_4_hours',
        defaultMessage: 'Ближайшие 4 часа'
    },
    next6Hours: {
        id: 'grid.menu.prematch_filter.next_6_hours',
        defaultMessage: 'Ближайшие 6 часов'
    },
    next12Hours: {
        id: 'grid.menu.prematch_filter.next_12_hours',
        defaultMessage: 'Ближайшие 12 часов'
    },
    nextDay: {
        id: 'grid.menu.prematch_filter.next_day',
        defaultMessage: 'Ближайший день'
    },
    next2Days: {
        id: 'grid.menu.prematch_filter.next_2_days',
        defaultMessage: 'Ближайшие 2 дня'
    }
});

function _localizedLink(message, onClick, isActive = false) {
    const linkClass = isActive ? 'dropdown--menu__link active' : 'dropdown--menu__link';

    return (
        <FormattedMessage {...message}>
            {(localizedMessage) =>
                <a href="#" className={linkClass} onClick={onClick}>
                    {localizedMessage}
                </a>}
        </FormattedMessage>
    );
}

export default class PreMatchMenu extends React.Component {
    static propTypes = {
        onFilterClick: React.PropTypes.func.isRequired,
        onClosing: React.PropTypes.func.isRequired,
        activeElement: React.PropTypes.any
    };

    constructor(props) {
        super(props);
    }

    render() {
        const cssClass = 'dropdown--menu-live-grid-filter';

        const {onFilterClick, onClosing, activeElement} = this.props;

        const curryFilter = (filter) => () => onFilterClick(filter);

        const elements = [
            {content: _localizedLink(messages.allTime, curryFilter(null), (activeElement === null))},
            {content: _localizedLink(messages.nextHour, curryFilter(1), (activeElement === 1))},
            {content: _localizedLink(messages.next2Hours, curryFilter(2), (activeElement === 2))},
            {content: _localizedLink(messages.next4Hours, curryFilter(4), (activeElement === 4))},
            {content: _localizedLink(messages.next6Hours, curryFilter(6), (activeElement === 6))},
            {content: _localizedLink(messages.next12Hours, curryFilter(12), (activeElement === 12))},
            {content: _localizedLink(messages.nextDay, curryFilter(24), (activeElement === 24))},
            {content: _localizedLink(messages.next2Days, curryFilter(48), (activeElement === 48))}
        ];

        const title = (<FormattedMessage {...messages.title}/>);

        return (
            <DropDownMenu cssClass={cssClass}
                          title={title}
                          elements={elements}
                          onClosing={onClosing}/>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/PreMatchMenu.jsx